import React, { useEffect } from "react"
import { Spacer } from "./Atoms"
import StickySidebar from "sticky-sidebar"
import L10n from "../../../lib/carrot-l10n"
import { RoundedRectangle } from "./roundedrectangle/RoundedRectangle"
import { RRHeaderWithHR } from "./roundedrectangle/RRHeaderWithHR"
import { LathamAndWatkinsInformational } from "../molecules/Molecules"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const render = (element) => element && (React.isValidElement(element) ? element : React.createElement(element))

const SideAndTopNavigationBarContent = ({ links }) => (
  <RoundedRectangle backgroundColor="mint-alternate">
    <RRHeaderWithHR>{l`client.topics`}</RRHeaderWithHR>
    {links}
  </RoundedRectangle>
)

export const LeftStickySidebar = ({
  links,
  contentId,
  showLWInformational = false,
  isEligibleExpensesPage = false
}) => {
  useEffect(() => {
    const stickySidebar = new StickySidebar("#left-sidebar", {
      containerSelector: `#${contentId}`,
      innerWrapperSelector: ".sidebar__inner",
      topSpacing: 25
    })
    return () => {
      stickySidebar.destroy()
    }
  })
  return (
    <>
      <div className="dn db-l" id="left-sidebar">
        <div className="sidebar__inner">
          <SideAndTopNavigationBarContent links={links} />
          {showLWInformational && (
            <>
              <Spacer height={1.5} />
              <LathamAndWatkinsInformational showEECopy={isEligibleExpensesPage} />
            </>
          )}
        </div>
      </div>

      <div className="db dn-l">
        <SideAndTopNavigationBarContent links={links} />
      </div>
    </>
  )
}

export const BodyWithLeftSidebarLayout = ({ contentId = "", sideBarElements, children }) => (
  <div id={contentId} className="flex flex-row-l flex-column flex-auto">
    <div className="w-220px-l">
      {sideBarElements.map((sideBar) => (
        <div key={sideBar.key || ""}>
          {render(sideBar)}
          <Spacer height={1.5} />
        </div>
      ))}
    </div>
    <div className="db-l dn">
      <Spacer width={3} />
    </div>
    <div className="db-ns dn">
      <Spacer height={3} />
    </div>
    <div className="db dn-ns">
      <Spacer height={1.5} />
    </div>
    <div className="flex flex-auto">{children}</div>
  </div>
)

export const CenteredLayout = ({ children }) => (
  <div className="w-100 flex flex-column items-center ph4-l ph2-m ph35-s h-100">
    <div className="ph3-ns w-100 flex flex-column items-center h-100">
      <div className="mw-968-l mw-600-m w-100 h-100">{children}</div>
    </div>
  </div>
)
